<template lang="pug">
form(@submit.prevent='onConfirm')
  modal.active(
    :active='showModal'
    @close='$router.back()',
    :title='`Solicitar revisão do Documento (${current.numero}/${current.ano})`'
  )
    div(slot='modal-body')
      h4.text-warning Atenção
      p Após solicitar revisão, o documento irá para situação "Em Revisão".
      p Este procedimento #[b não pode ser desfeito].
      .divider
      form-group(label="Informe o motivo para solicitar revisão" :validation="$v.motivo")
        textarea.form-input(v-model="$v.motivo.$model" rows="4")
    div(slot='modal-footer')
      button.btn.btn-primary(
        :disabled='$v.$invalid || loading',
        :class='{ loading }'
      )
        btn-content(name='confirm' label="Solicitar revisão")
</template>

<script>
import toastErrors from '@/lib/errors/toastErrors'
import { minLength, required } from 'vuelidate/lib/validators'

export default {
  vuex: {
    'fiscalizacao/docs': {
      state: ['current'],
      actions: ['fetchSolicitarRevisao'],
    },
  },
  data() {
    return {
      motivo: '',
      loading: false,
      showModal: true,
    }
  },
  methods: {
    async onConfirm() {
      try {
        this.loading = true
        const { id } = this.current
        const params = { id, motivo: this.motivo }
        await this.fetchSolicitarRevisao(params)
        this.$toaster.success('Solicitado revisão com sucesso')
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      } finally {
        this.loading = false
      }
    },
  },
  validations: {
    motivo: {
      required,
      minLength: minLength(10),
    },
  },
}
</script>
